
// @ts-ignore
export const setAll = (state, all) => {
  state.all = all;
};

// @ts-ignore
export const setOne = (state, one) => {
  state.one = one;
};

// @ts-ignore
export const setGeneratedExternal = (state, generatedExternal) => {
  state.generatedExternal = generatedExternal;
};
